/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompetenceTemplateDTO,
    CompetenceTemplateDTOFromJSON,
    CompetenceTemplateDTOFromJSONTyped,
    CompetenceTemplateDTOToJSON,
} from './CompetenceTemplateDTO';

/**
 * 
 * @export
 * @interface CompetenceTemplateDTOPagedResponse
 */
export interface CompetenceTemplateDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CompetenceTemplateDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetenceTemplateDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof CompetenceTemplateDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<CompetenceTemplateDTO>}
     * @memberof CompetenceTemplateDTOPagedResponse
     */
    data?: Array<CompetenceTemplateDTO> | null;
}

export function CompetenceTemplateDTOPagedResponseFromJSON(json: any): CompetenceTemplateDTOPagedResponse {
    return CompetenceTemplateDTOPagedResponseFromJSONTyped(json, false);
}

export function CompetenceTemplateDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetenceTemplateDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(CompetenceTemplateDTOFromJSON)),
    };
}

export function CompetenceTemplateDTOPagedResponseToJSON(value?: CompetenceTemplateDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(CompetenceTemplateDTOToJSON)),
    };
}

